import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useCreateCategoryMutation } from 'App/services/categoryServiceApi';
import { toast } from 'react-toastify';

export default function FormDialog() {
  const [open, setOpen] = useState(false);
  const [categoryName, setCategoryName] = useState('');
  const [image, setImage] = useState(null); 
  const [imagePreview, setImagePreview] = useState(''); 
  const [imgError, setImgError] = useState('');
  const [createCategory, { isLoading }] = useCreateCategoryMutation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCategoryName('');
    setImage(null);
    setImagePreview('');
    setImgError('');
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      setImgError('');
      setImagePreview(URL.createObjectURL(file)); 
    } else {
      setImgError('Please select a valid image file.');
    }
  };

  const handleAddCategory = async (event) => {
    event.preventDefault();
    if (!categoryName) {
      toast.error("Category name is required.");
      return;
    }

    const formData = new FormData();
    formData.append('name', categoryName);
    if (image) {
      formData.append('imagePath', image);
    }


    try {

      if(categoryName && image){
      await createCategory(formData).unwrap();
      toast.success("Category successfully created!");
      handleClose();
      }
      else{
        toast.error("Image is Required")
      }
    } catch (error) {
      toast.error(error?.data?.error);
    }
  };  

  return (
    <React.Fragment>
      <Button variant="contained" color="light" onClick={handleClickOpen}>
        Add Category
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleAddCategory,
        }}
      >
        <DialogTitle>Add Category</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            name="name"
            label="Category Name"
            type="text"
            fullWidth
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
          />
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ marginTop: '16px' }}
          />
          {imagePreview && (
            <div style={{ marginTop: '16px' }}>
              <img src={imagePreview} alt="Preview" style={{ maxWidth: '100%', maxHeight: '300px' }} />
            </div>
          )}
          {imgError && <p style={{ color: "red" }}>{imgError}</p>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" disabled={isLoading}>
            {isLoading ? 'Adding...' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
